module.exports = __webpack_public_path__ + "static/media/block-play.52d61473.svg";